<template>
  <a :href="href" target="_blank">
    <span class="sr-only">(opens in a new tab) </span>
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      required: true,
    }
  },
  name: "NewTabA11y"
}
</script>

<style scoped>

</style>